import React, { useEffect, useState } from 'react';
import Modal from '../Modal/ReactBootstrapModal';
import {
    buildCalendarUrl,
    getRandomKey,
    shouldDownloadIcsFile,
} from './helpers';
import { addToCalModal, eventFeedForTrackCalls } from '../../utils/addToCalendarConstants';
import './CalendarAdd.scss';
import config from '../../../config';
import { gtag } from '../Analytics/gtag';

const AddEventToCalendar = (props) => {
    const [showPopup, setShowPopup] = useState(false);
    const [isIEBrowser, setIsIEBrowser] = useState(false);
    const { eventDetails, uiElement, showOnLoad = false, isOnDashboard = false, loggedInUserId = null, 'data-testid': dataTestId } = props;

    useEffect(() => {
        let isIE = false;
        if (typeof window !== 'undefined' && window.navigator.msSaveOrOpenBlob && window.Blob) {
            isIE = true;
        }
        setIsIEBrowser(isIE);
        if (showOnLoad) {
            setShowPopup(true);
        }
    }, [showOnLoad]);

    const handleAddToCalendar = () => {
        // segment track call on add to calendar Mid_Funnel B
        let trackCallsLabeltext = eventFeedForTrackCalls.MID_FUNNEL_A;
        if (isOnDashboard) {
            trackCallsLabeltext = eventFeedForTrackCalls.MID_FUNNEL_B;
        } else if (uiElement === 'button') {
            trackCallsLabeltext = eventFeedForTrackCalls.TOP_FUNNEL;
        }

        if (loggedInUserId && trackCallsLabeltext) {
            gtag('event', {
                category: 'Add To Calendar',
                context: `${trackCallsLabeltext} - Event Id: ${eventDetails.id}`,
            });
            // segment track call - mapped to GA4
            if (window && window.analytics) {
                window.analytics.track(trackCallsLabeltext, {
                    userId: loggedInUserId,
                    eventId: eventDetails.id,
                });
            }
        }
        setShowPopup(true);
    };

    const handleCalendarLinkClick = (e) => {
        e.preventDefault();
        const url = e.currentTarget.getAttribute('href');
        if (shouldDownloadIcsFile(url)) {
            const filename = 'calendar-event.ics';
            const blob = new Blob([url], { type: 'text/calendar;charset=utf-8' });

            if (isIEBrowser) {
                window.navigator.msSaveOrOpenBlob(blob, filename);
            } else {
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.setAttribute('download', filename);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        } else {
            window.open(url, '_blank');
        }

        gtag('event', {
            category: 'Add To Calendar',
            context: `${eventFeedForTrackCalls.END_FUNNEL} - Event Id: ${eventDetails.id}`,
        });
        // segment track call on add to calendar End_Funnel - Mapped to GA4
        if (loggedInUserId && window && window.analytics) {
            window.analytics.track(eventFeedForTrackCalls.END_FUNNEL, {
                userId: loggedInUserId,
                eventId: eventDetails.id,
            });
        }
        setShowPopup(false);
    };

    const getFullAddress = () => {
        const location = eventDetails?.eventLocations[0] || {};
        const placeName = (location.placeName) ? `${location.placeName}, ` : '';
        const streetAddress = (location.streetAddress) ? `${location.streetAddress}, ` : '';
        const cityStateZip = (location.cityStateZip) ? location.cityStateZip : '';
        const fullAddress = `${placeName}${streetAddress}${cityStateZip}`;
        return fullAddress;
    };

    const renderCalendarLinks = () => {
        const listitems = [
            { iCal: 'Apple Calendar' },
            { google: 'Google Calendar' },
            { outlookcom: 'Outlook Calendar' },
        ];

        const event = {
            title: eventDetails.name,
            description: `For the latest event information, see`,
            location: getFullAddress(),
            startDate: eventDetails.eventSchedule.eventStartUtc,
            endDate: eventDetails.eventSchedule.eventEndUtc,
            eventTimezone: eventDetails.eventSchedule.timeZone.value,
        };

        const eventURL = `${config.appHost}/events/${eventDetails.id}`;
        const items = listitems.map(listItem => {
            const currentItem = Object.keys(listItem)[0];
            const currentLabel = listItem[currentItem];
            const updatedEvent =
                currentItem === 'iCal'
                    ? {
                        ...event,
                        location: event.location.replaceAll(', ', ' - '),
                    }
                    : { ...event, description: `${event.description} ${eventURL}` };
            return (
                <li key={getRandomKey()}>
                    <a
                        className={`${currentItem}-link`}
                        onClick={handleCalendarLinkClick}
                        href={buildCalendarUrl(
                            updatedEvent,
                            currentItem,
                            isIEBrowser,
                        )}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid={dataTestId && `${dataTestId}.modal.${currentItem}-link`}
                    >
                        {currentLabel}
                    </a>
                </li>
            );
        });

        return (
            <div className="react-add-to-calendar">
                <div className={'react-add-to-calendar__dropdown'}>
                    <ul>{items}</ul>
                </div>
            </div>
        );
    };

    return (
        <>
            <div className={`add-calendar-wrap ${isOnDashboard ? 'dashboard-add-to-calendar' : ''}`}>
                <button
                    type="button"
                    className={`btn ${isOnDashboard ? 'white-bg' : ''} ${uiElement === 'button' ? 'btn-xl btn-primary font-weight-normal' : 'add-to-cal-link'}`}
                    onClick={handleAddToCalendar}
                    data-testid={dataTestId && `${dataTestId}.btn`}
                >
                    {uiElement === 'link' && (<i className="far fa-calendar" />)} Add to calendar
                </button>
                {showPopup && (
                    <Modal className="popup-xs" visible={showPopup} fade={true} dialogClassName="modal-dialog-centered">
                        <div className="modal-body text-center">
                            <div className="close-icon" onClick={() => setShowPopup(false)} data-testid={dataTestId && `${dataTestId}.modal.close-btn`}>
                                <i className="utr utr-close" />
                            </div>
                            <h3 className="modal-title" data-testid={dataTestId && `${dataTestId}.modal.title`}>{addToCalModal.TITLE}</h3>
                            <p className="payment-text" data-testid={dataTestId && `${dataTestId}.modal.subtitle`}>{addToCalModal.SUB_TITLE}</p>
                            <div className="calendar-btn-wrap">
                                <div className="cal-btn d-flex justify-content-start align-items-center">
                                    {renderCalendarLinks()}
                                </div>
                            </div>
                        </div>
                    </Modal>
                )}
            </div>
        </>
    );
};
export default AddEventToCalendar;
